import { useEffect } from 'react';

/**
 * Publishes the *visual* viewport height as the --app-height CSS variable.
 *
 * On iOS Safari 100vh is the large viewport (chrome collapsed), so a 100vh
 * column is taller than what the user can see while the URL bar is showing,
 * and the on-screen keyboard shrinks the visual viewport without changing any
 * CSS unit. Tracking visualViewport is the only thing that follows both.
 */
export const useViewportHeight = () => {
  useEffect(() => {
    const vv = window.visualViewport;

    const apply = () => {
      const height = vv ? vv.height : window.innerHeight;
      const offsetTop = vv ? vv.offsetTop : 0;
      document.documentElement.style.setProperty('--app-height', `${height}px`);
      document.documentElement.style.setProperty('--app-offset-top', `${offsetTop}px`);
    };

    apply();

    if (vv) {
      vv.addEventListener('resize', apply);
      vv.addEventListener('scroll', apply);
    }
    window.addEventListener('resize', apply);
    window.addEventListener('orientationchange', apply);

    return () => {
      if (vv) {
        vv.removeEventListener('resize', apply);
        vv.removeEventListener('scroll', apply);
      }
      window.removeEventListener('resize', apply);
      window.removeEventListener('orientationchange', apply);
      document.documentElement.style.removeProperty('--app-height');
      document.documentElement.style.removeProperty('--app-offset-top');
    };
  }, []);
};

export default useViewportHeight;
